<template>
  <component :is="layout">
    <slot />
  </component>
</template>

<script>
const defaultMobile = "AppLayoutMobile";
export default {
  name: "AppLayout",
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultMobile
        return () => import(`@/layouts/${layout}.vue`);
    },
  },
};
</script>
